import { BuyNowOrderResponse } from 'common/api/e-comm/orders/service';

export enum Codes {
    ECOMM_0006 = 'ecomm-0006',
    ECOMM_0011 = 'ecomm-0011',
    ECOMM_0017 = 'ecomm-0017',
    ECOMM_0018 = 'ecomm-0018',
    ECOMM_0020 = 'ecomm-0020',
    ECOMM_0022 = 'ecomm-0022',
    ECOMM_CATCH_ALL = '',
}

export interface BuyNowError {
    title: string;
    message: string;
    isWarning: boolean;
    code: Codes;
}

export const handleError = (result: BuyNowOrderResponse): BuyNowError => {
    let title = '';
    let message = '';
    let isWarning = false;
    const code = result.errorCode;
    switch (code) {
        case Codes.ECOMM_0011: {
            title = 'Product Unavailable';
            message =
                'Unfortunately the product you tried to purchase is unavailable. To learn more, call Customer Support at 800-727-4715 (option 3).';
            break;
        }
        case Codes.ECOMM_0017: {
            title = 'Transaction Could Not Be Completed';
            message = 'There was an error from the card issuer. Please try again later.';
            break;
        }
        case Codes.ECOMM_0018: {
            title = 'Earnings Amount\nHas Changed';
            message = `This order now earns $${Math.round(result.earnings || 0).toFixed(2)}`;
            isWarning = true;
            break;
        }
        case Codes.ECOMM_0020: {
            title = 'Order Pending Review';
            message = 'You’ll receive an email with more information after we complete the review.';
            isWarning = true;
            break;
        }
        case Codes.ECOMM_0022: {
            title = 'Unable to Process Payment';
            message =
                'Sorry, we were unable to process your payment method. Please try again, or choose a different default form of payment by continuing your purchase through Add to Cart > Checkout.';
            break;
        }
        default: {
            const codeNumber = code ? code.split('-')[1] : '';
            const errorCodeText = codeNumber ? ` (Error ${codeNumber}.)` : '';
            title = 'Something Went Wrong';
            message = `Unfortunately your transaction could not be completed.${errorCodeText} Please try again, or select Add to Cart as an alternative to Buy Now.`;
            break;
        }
    }

    return { title, message, isWarning, code } as BuyNowError;
};
